import { render, staticRenderFns } from "./W6.vue?vue&type=template&id=761fbb1a&scoped=true&"
import script from "./W6.vue?vue&type=script&lang=js&"
export * from "./W6.vue?vue&type=script&lang=js&"
import style0 from "./W6.vue?vue&type=style&index=0&id=761fbb1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fbb1a",
  null
  
)

export default component.exports